import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'includes',
  standalone: true,
})
export class IncludesPipe implements PipeTransform {
  transform<T>(list: string | T[], value: any): boolean {
    if (!list.length) {
      return false;
    }
    return list.includes(value);
  }
}
